export function stepReducer( state = 0, action ){
    switch( action.type ){
        case "SET_CREATE_NEW_BRANCH_STEP": return action.payload
        default: return state
    }
}

export function isFiscalReducer(state = false, action){
    switch( action.type ){
        case "BRANCH_IS_FISCAL": return action.payload
        default: return state
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/branches/create/steps/reducers.js